import { commonOptions } from '@/config/options'
import { PageContext } from '@zto/zpage-runtime'
import { DeductionType } from '@/config/enums'


export function deductionAction(){
  return {
    width: 800,
    labelWidth: 160,
    title: '余额扣款',
    formItems: [
      {
        label: '扣款类目',
        type: 'select',
        prop: 'deductCategory',
        options: commonOptions.deductionClass,
        span: 12,
        required: true
      },
      {
        label: '扣款金额',
        type: 'input',
        prop: 'deductAmount',
        span: 12,
        required: true,
        rules: [
          { required: true, message: '请输入扣款金额' },
          { pattern: /^(0|[1-9]\d*)(\.\d{1,2})?$/, message: '请输入正确的金额格式，最多两位小数' }
        ]
      },
      {
        label: '扣款原因',
        type: 'select',
        prop: 'deductReason',
        span: 12,
        required: true,
        dynamicAttrs: ({ data }: PageContext) => {
          let options = []

          if (data.deductCategory === DeductionType.account) {
            options = commonOptions.accountBalance
            data.deductReason = ''
          } else {
            options = commonOptions.commissionBalance
            data.deductReason = ''
          }
          return {
            options: options
          }
        }
      },
      {
        label: '备注',
        type: 'textarea',
        prop: 'remark',
        span: 24,
        required: true,
        maxlength: 100,
        showWordLimit: true,
        placeholder: '请输入备注，最多100个字符'
      }
    ]
  }
}




export function deductionRecordAction() {
  return {
    width: 1200,
    labelWidth: 0,
    title: '扣款记录',
    formAttrs: {
      disabled: true
    },
    // 在打开弹窗时调用接口获取扣款记录
    onShow: async ({ data, app }: PageContext) => {
      console.log('打开扣款记录弹窗，当前行数据:', data)

      let listData: any[] = []

      try {
        const res = await app.api.fetch({
          url: '/sys/admin/balance/deduct/list',
          method: 'POST',
          data: {
            userCode: data.userCode,
            pageNum: 1,
            pageSize: 100
          }
        })

        console.log('扣款记录接口返回:', res)

        // 全局拦截器已经提取了 result，所以 res 就是 result 对象
        if (res && res.list) {
          listData = res.list
          console.log('扣款记录列表:', listData)
        } else {
          console.warn('扣款记录为空或格式不正确:', res)
        }
      } catch (error) {
        console.error('获取扣款记录失败:', error)
        app.useMessage().Message.error('获取扣款记录失败')
      }

      const payload = {
        payload: {
          list: listData
        }
      }
      console.log('返回给弹窗的数据:', payload)
      return payload
    },
    formItems: [
      {
        label: '',
        labelWidth: 0,
        type: 'edit-table',
        prop: 'list',
        span: 24,
        noOperation: true,
        disabled: true,
        autoHeight: true,
        border: true,
        columns: [
          {
            label: '扣款日期',
            prop: 'deductDate',
            minWidth: 160
          },
          {
            label: '扣款类目',
            prop: 'deductCategoryDesc',
            minWidth: 100
          },
          {
            label: '金额',
            prop: 'deductAmount',
            minWidth: 100,
            formatter: (row: any) => {
              const amount = row.deductAmount || 0
              return `-${amount.toFixed(2)}`
            }
          },
          {
            label: '原因',
            prop: 'deductReasonDesc',
            minWidth: 120
          },
          {
            label: '备注',
            prop: 'remark',
            minWidth: 200
          },
          {
            label: '扣款前余额',
            prop: 'beforeBalance',
            minWidth: 120,
            formatter: (row: any) => {
              const balance = row.beforeBalance || 0
              return balance.toFixed(2)
            }
          },
          {
            label: '扣款后余额',
            prop: 'afterBalance',
            minWidth: 120,
            formatter: (row: any) => {
              const balance = row.afterBalance || 0
              return balance.toFixed(2)
            }
          },
          {
            label: '操作人',
            prop: 'operator',
            minWidth: 100
          }
        ]
      }
    ],
    actions: {
      close: {}
    }
  }
}




